class LoginForm extends HTMLElement {
  constructor() {
    super();
    this.loginForm = null;
    this.recoverForm = null;
  }

  connectedCallback() {
    this.loginForm = this.querySelector(".login-form");
    this.recoverForm = this.querySelector(".recover-form");

    if (window.location.href.includes("#recover")) {
      this.handleRecover();
    }

    const recoverBtn = this.querySelector(".recover-button");
    const closeBtn = this.querySelector(".close-button");
    recoverBtn.addEventListener("click", () => {
      this.handleRecover();
    });
    closeBtn.addEventListener("click", () => {
      this.handleBackToLogin();
    });
  }

  handleBackToLogin() {
    this.recoverForm.style.display = "none";
    this.loginForm.style.display = "grid";
    this.querySelectorAll("[data-login]").forEach((el) => {
      el.innerHTML = el.dataset.login;
    });
  }

  handleRecover() {
    this.recoverForm.style.display = "grid";
    this.loginForm.style.display = "none";
    this.querySelectorAll("[data-recover]").forEach((el) => {
      el.innerHTML = el.dataset.recover;
    });
  }
}

customElements.define("login-form", LoginForm);

/*
  Settings Selector
*/

class SettingSelector extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    Array.from(this.querySelectorAll("button[data-setting]")).forEach(
      (setting) => {
        setting.addEventListener("click", (e) => {
          const divs = Array.from(this.querySelectorAll(`div[data-setting]`));
          const target = e.target.dataset.setting;
          const targetEl = this.querySelector(`div[data-setting="${target}"]`);

          divs.forEach((setting) => setting.classList.add("hidden"));
          targetEl.classList.remove("hidden");
        });
      }
    );
  }
}
customElements.define("setting-selector", SettingSelector);

/*
Country Select
*/

class CountrySelect extends SelectInput {
  constructor() {
    super();
    this.select = null;
    this.activeOption = null;
  }

  connectedCallback() {
    this.select = this.querySelector("select");
    const active = this.dataset.active;

    if (active) {
      this.setActiveValue(active);
    }

    this.select.addEventListener("change", (e) => {
      const provinceSelect = document.querySelector("province-select");

      this.setActiveValue(e.target.value);
      provinceSelect.renderOptions();
    });
  }

  setActiveValue(val) {
    const provinceSelect = document.querySelector("province-select");
    const target = this.querySelector(".select-target");
    const options = Array.from(this.querySelectorAll("option"));

    this.activeOption = options.find((o) => o.value === val);

    if (this.activeOption) {
      this.select.value = this.activeOption.value;
      target.innerHTML = this.activeOption.value;
    }
  }
}

customElements.define("country-select", CountrySelect);

/*
Province Select
*/

class ProvinceSelect extends SelectInput {
  constructor() {
    super();
    this.select = null;
    this.target = null;
  }

  connectedCallback() {
    this.select = this.querySelector("select");
    this.target = this.querySelector(".select-target");
    this.renderOptions();
    this.setActive();
  }

  renderOptions() {
    const countrySelect = document.querySelector("country-select");
    if (countrySelect.activeOption) {
      const provinces = JSON.parse(
        countrySelect.activeOption.dataset.provinces
      );

      this.select.innerHTML = "";
      this.target.innerHTML = "";

      if (provinces.length > 0) {
        this.select.required = true;
        this.style.display = "block";

        provinces.forEach((province) => {
          const option = document.createElement("option");
          option.value = province[0];
          option.innerHTML = province[1];
          this.select.appendChild(option);
        });
      } else {
        this.select.required = false;
        this.style.display = "none";
      }
    }
  }

  setActive() {
    const active = this.dataset.active;
    if (active) {
      this.target.innerHTML = active;
      this.select.value = active;
    }
  }
}

customElements.define("province-select", ProvinceSelect);

/*
Register Form
*/

class RegisterForm extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("submit", (e) => {
      e.preventDefault();

      const form = e.target;
      const consent = form.querySelector('[type="checkbox"]');
      const email = form.querySelector('[type="email"]').value;
      const listId = this.dataset.listId;
      const body = { email, listId };
      const config = {
        body: JSON.stringify(body),
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Accept: `application/json`,
        },
      };

      if (consent.checked) {
        try {
          fetch(
            "https://hunni-serverless.vercel.app/api/ourx/subscribe",
            config
          )
            .then((res) => res.json())
            .then((data) => {
              form.submit();
            });
        } catch (e) {
          alert("Error submitting the register form");
        }
      } else {
        form.submit();
      }
    });
  }
}

customElements.define("register-form", RegisterForm);

/*
Reset Password
*/

class ResetPassword extends HTMLElement {
  constructor() {
    super();
  }

  connectedCallback() {
    this.addEventListener("click", (e) => {
      e.preventDefault();
      this.handleReset();
    });
  }

  handleReset() {
    fetch("/account/logout", {
      method: "GET",
      headers: {
        "Content-Type": "application/x-www-form-urlencoded",
      },
    }).then((response) => {
      if (response.ok) {
        window.location.href = "/account/login#recover";
      }
    });
  }
}

customElements.define("reset-password", ResetPassword);

/* Customer Edit Address Form */

class AddressForm extends HTMLElement {
  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    const openBtn = this.querySelector(".form-open");
    const closeBtn = this.querySelector(".form-close");
    const form = this.querySelector(".edit-form");

    openBtn.addEventListener("click", () => {
      form.classList.toggle("hidden");
    });
    closeBtn.addEventListener("click", () => {
      form.classList.toggle("hidden");
    });
  }
}

customElements.define("address-form", AddressForm);

/* Customer Addresses List */

class AddressesList extends HTMLElement {
  connectedCallback() {
    this.setupListeners();
  }

  setupListeners() {
    const openBtn = this.querySelector(".new-open");
    const closeBtn = this.querySelector(".new-close");
    const form = this.querySelector(".new-form");

    openBtn.addEventListener("click", () => {
      form.classList.toggle("hidden");
    });
    closeBtn.addEventListener("click", () => {
      form.classList.toggle("hidden");
    });
  }
}

customElements.define("addresses-list", AddressesList);

class FormError extends HTMLElement {
  connectedCallback() {
    this.closeBtn = this.querySelector(".modal-close");
    this.modal = this.querySelector(".modal");
    this.setupListeners();
  }

  setupListeners() {
    setTimeout(() => {
      this.modal.style.transform = "translateY(-400%)";
    }, 4000);

    this.closeBtn.addEventListener("click", () => {
      this.modal.style.transform = "translateY(-400%)";
    });
  }
}

customElements.define("form-error", FormError);
